import React from "react";
import Loadable from "react-loadable";
import { Route, Switch, RouteComponentProps } from "react-router-dom";

import { LOADABLE_COMPONENT_DELAY } from "@config/consts";
import { ROUTES } from "@config/soft.routing";

import { Container } from "@ui/Atoms/Grid";
import { Section, FadeInContainer } from "@ui/Atoms";

import { NotFound } from "@soft/pages/NotFound";

import { FormHeader } from "./components";
import { DeclareEmployeePageSkeleton } from "./DeclareEmployee.skeletons";

const LoadableEmployeeDetails: any = Loadable({
  loader: () => import("./steps/EmployeeDetails/EmployeeDetails"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.EmployeeDetails;
    return <Component {...props} />;
  },
  loading: DeclareEmployeePageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const LoadableSalaryProposal: any = Loadable({
  loader: () => import("./steps/SalaryProposal/SalaryProposal"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.SalaryProposal;
    return <Component {...props} />;
  },
  loading: DeclareEmployeePageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const LoadableCheckout: any = Loadable({
  loader: () => import("./steps/Checkout/Checkout"),
  render(loaded: any, props: any): JSX.Element {
    const Component = loaded.Checkout;
    return <Component {...props} />;
  },
  loading: DeclareEmployeePageSkeleton,
  delay: LOADABLE_COMPONENT_DELAY,
});

const DeclareEmployee = (props: RouteComponentProps): React.ReactElement => (
  <Container>
    <Section flat smallMargins>
      <FormHeader currentPath={props.location.pathname} />
    </Section>
    <Section small>
      <Switch>
        <Route
          exact
          path={ROUTES.DECLARE_EMPLOYEE}
          render={() => (
            <FadeInContainer>
              <LoadableEmployeeDetails />
            </FadeInContainer>
          )}
        />
        <Route
          exact
          path={ROUTES.DECLARE_EMPLOYEE_SALARY}
          render={() => (
            <FadeInContainer>
              <LoadableSalaryProposal />
            </FadeInContainer>
          )}
        />
        <Route
          exact
          path={ROUTES.DECLARE_EMPLOYEE_CHECKOUT}
          render={() => (
            <FadeInContainer>
              <LoadableCheckout />
            </FadeInContainer>
          )}
        />
        <Route render={() => <NotFound isNested />} />
      </Switch>
    </Section>
  </Container>
);

export { DeclareEmployee };
